import { useContext } from 'react';

import { BottomTableContext } from '../contexts';

export const useBottomTableContext = () => useContext(BottomTableContext);
